var vec3 = require('gl-vec3');

export default function (noa) {
  return {
    name: 'animations',
    order: 100,
    state: {
      animator: null,
      lastRunning: false,
      lastJumping: false,
      currentState: ""
    },
    onAdd: function onAdd(eid, state) {
      // implicitly assume there's already a position component
      if (state.animator) {
        console.log("animator constructor");
        state.animator.playGroup("idle");
      }
    },
    onRemove: function onRemove(eid, state) {//
    },
    renderSystem: function renderSystem(dt, states) {
      // before render move each mesh to its render position, 
      // set by the physics engine or driving logic
      var ents = noa.entities;
      states.forEach(function (state) {
        var id = state.__id;
        var moveState = ents.getMovement(id);

        if (state.lastRunning != moveState.running || state.currentState === "landingDone") {
          if (moveState.running) {
            state.animator.playGroup("run", true);
          } else {
            state.animator.playGroup("idle", true);
          }

          state.lastRunning = moveState.running;
          state.currentState = "moving";
        }

        if (state.currentState === "jumping" && moveState.onGround && !moveState.jumping) {
          state.currentState = "landing";
          var group = state.animator.playGroup("land");
          group.onAnimationGroupEndObservable.addOnce(function () {
            state.currentState = "landingDone";
          });
        }

        if (state.lastJumping != moveState.jumping) {
          if (moveState.jumping) {
            state.animator.playGroup("jump", false);
            state.currentState = "jumping";
          }

          state.lastJumping = moveState.jumping;
        }
      });
    }
  };
}